import { api } from "../common/http";
const toPage = (res) => res.data;

const AdminPlatformUserApi = {
  list: async ({
  page = 0,
  size = 20,
  sort = "firstName,asc",
  q,
  country,
} = {}) => {
  const params = { page, size, sort };

  if (q?.trim()) params.q = q.trim();
  if (country?.trim()) params.country = country.trim();
  const res = await api.get("/admin/users", { params }); 
  return toPage(res);
},


  getById: async (id) => (await api.get(`/admin/users/${id}`)).data,
  getByUuid: async (uuid) => (await api.get(`/admin/users/uuid/${uuid}`)).data,
  create: async (data) => (await api.post("/admin/users", data)).data,
  remove: async (id) => (await api.delete(`/admin/users/${id}`)).data,
};

export default AdminPlatformUserApi;
